module.exports = __webpack_public_path__ + "static/media/03.8a4422a8.jpg";